import PropTypes from "prop-types"
import { TextField } from "@mui/material"

export default function QueryInput({
  question,
  onQuestionChange,
  onQuestionBlur,
  disabled,
}) {
  return (
    <TextField
      label="Question"
      variant="outlined"
      fullWidth
      multiline
      rows={4}
      placeholder="What are my 5 top & bottom performers in the last day?"
      value={question}
      onChange={onQuestionChange}
      onBlur={onQuestionBlur}
      focused
      disabled={disabled}
    />
  )
}

QueryInput.propTypes = {
  question: PropTypes.string.isRequired,
  onQuestionChange: PropTypes.func.isRequired,
  onQuestionBlur: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
}
